import React, { useState } from 'react';
import UserSection from '../UserSection/index';
import { NavMenuProps } from '../types';
import {
  UptimeMobileNavMenu,
  UptimeBox,
} from '@uptime/uptime-component';
import { IconButton } from '@mui/material';
import MarketplaceThemeProvider from 'containers/MarketplaceThemeProvider';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { EditPreferencePath } from 'utils/routes';
import { AccountCircleRounded, LogoutRounded } from '@mui/icons-material';
import { StyledActionButton, StyledButtonWrapper } from './MobileNavMenu.style';
import { useUserData } from 'hooks';
import { UptimeMarketPlace } from '@uptime/uptime-component';
import { useChatWidget } from 'containers/ChatWidgetContainer';

/**
 * MobileNavMenu Props
 */
export interface MobileNavMenuProps extends NavMenuProps {
  /** Determines if the mobile navigation menu sidesheet is open */
  isOpen: boolean;
  isAuthenticated: boolean;
  oidcAuthen?: any;
}
/**
 * Renders mobile navigation menu sidesheet on click of hamburger menu
 */


const MobileNavMenu: React.FC<MobileNavMenuProps> = ({
  // setPunchOutModalContent,
  // openPunchOutModal,
  closeMobileNavMenu,
  onClickNavMenu,
  manageItems,
  isOpen,
  locale,
  isAuthenticated,
  oidcAuthen
}) => {
  const [isOpenLogoutModal, setOpenLogoutModal] = useState<boolean>(false);
  const { t } = useTranslation(['topNav', 'editProfile']);
  const history = useHistory();
  const { handleWidgetIndex } = useChatWidget();
  const dataUser = useUserData();

  const handleLogoutModal = (e: any) => {
    e.stopPropagation();
    setOpenLogoutModal(true);
  };
  return (
    <MarketplaceThemeProvider>
      <UptimeMarketPlace.Drawer
        anchor="left"
        open={isOpen}
        onClose={closeMobileNavMenu}
        PaperProps={{
          sx: {
            backgroundColor: "primary.main",
            width: "315px",
          }
        }}
        sx={{
          zIndex: '1400', 
        }}
        handleWidgetIndex={handleWidgetIndex}

      >
        <UptimeBox height="100%" display="flex" flexDirection="column" overflow="hidden">
          {/* Mobile Menu Header */}
          <UptimeBox padding={2} alignItems="center" justifyContent="space-between" display="flex">
            <UserSection oidcAuthen={oidcAuthen} isAuthenticated={isAuthenticated} openMobileNavMenu={isOpen} onCloseMobileNavMenu={closeMobileNavMenu} showUserName isOpenLogoutModal={isOpenLogoutModal} setOpenLogoutModal={setOpenLogoutModal}/>
            <IconButton onClick={closeMobileNavMenu}>
              <CloseIcon sx={{ color: "common.white" }}/>
            </IconButton>
          </UptimeBox>
          {/* Mobile Menu Body */}
          <UptimeBox marginX={3} marginBottom={4} role="presentation" flex={2} overflowY="scroll">
            <UptimeMobileNavMenu >
              {manageItems.map((item: any) => {
                  return (
                    <UptimeMobileNavMenu.SubNav key={item.key} item={item} onClick={onClickNavMenu} locale={locale} />
                  )
              })}
            </UptimeMobileNavMenu>
          </UptimeBox>
          {/* Mobile Menu Footer */}
          <StyledButtonWrapper padding={2}>
            <StyledActionButton textTransform="capitalize" fullWidth onClick={() => {
              if(dataUser?.lockedOut) return;
              history.push(EditPreferencePath);
              closeMobileNavMenu();
            }}>
              <AccountCircleRounded />
              {t('editProfile:pageTitle')}
            </StyledActionButton>
            <StyledActionButton fullWidth onClick={(e:any) => handleLogoutModal(e)}>
              <LogoutRounded />
              {t('topNav:logOut')}
            </StyledActionButton>
          </StyledButtonWrapper>
        </UptimeBox>
      </UptimeMarketPlace.Drawer>
    </MarketplaceThemeProvider>
  );
};

export default MobileNavMenu;
